import { getCsrfToken } from '../../utils/csrf'

declare var window: { Gites: { jwt_url: string }};

const getJwtUri = () : string => window.Gites.jwt_url

export const fetchAccommodationMapsSnippet = async (accomodation_url: string) : Promise<string> => {
  const response = await fetch(accomodation_url, {
    method: "GET",
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  return await response.text()
}

export const authorizationCallback = async (done: (_:string) => void ) => {
  const response = await fetch(getJwtUri(), {
    method: "POST",
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': getCsrfToken()
    }
  })
  const text = await response.text()
  done(text)
}
